<div class="card">
  <div class="card-body">
    <alert *ngIf="pageData.isUnsaved" [dismissible]="false" type="primary">
      You have unsaved changes.
    </alert>
    <!-- Only worth showing on group sessions — a one-to-one sheet has a single row. -->
    <div class="search-box mb-2 d-inline-block" *ngIf="pageData.gridRowLists.length > 1">
      <div class="position-relative">
        <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm" />
        <i class="bx bx-search-alt search-icon"></i>
      </div>
    </div>
    <!-- Family filter: hides non-members via the SAME rowMatches predicate as the search
         (hide-don't-remove — a save while filtered keeps every attendee's answers). -->
    <div class="mb-2 ms-2 d-inline-block align-top" style="min-width: 220px;"
      *ngIf="pageData.gridRowLists.length > 1 && familyOptions.length">
      <ng-select [items]="familyOptions" bindLabel="displayLabel" bindValue="familyGuid"
        [clearable]="true" placeholder="Filter by family"
        [ngModel]="selectedFamilyGuid" (ngModelChange)="onFamilyChange($event)">
        <!-- Same-surname families are told apart by their reference number in the label
             and their address on the option row. -->
        <ng-template ng-option-tmp let-item="item">
          <div>{{ item.displayLabel }}</div>
          <small class="text-muted" *ngIf="item.formattedAddress">{{ item.formattedAddress }}</small>
        </ng-template>
      </ng-select>
    </div>
    <form [formGroup]="pageData.formGroup">
      <div class="table-responsive">
        <table class="table align-middle table-nowrap datatables mb-0">
          <thead>
            <tr>
              <th *ngFor="let col of columnsSchema" [class.d-none]="col.detailInfo.isHiddenByCurrentVariant">
                <div class="d-flex gap-1 align-items-bottom">
                  {{ col.title}}
                  <div class="dropdown" dropdown placement="bottom-right"
                    [class.d-none]="!col.detailInfo.gridHeaderEdit || !col.detailInfo.gridEdit" [autoClose]="true"
                    [insideClick]="true">
                    <a class="dropdown-toggle" data-toggle="dropdown" dropdownToggle aria-expanded="false">
                      <i class="fa fas fa-chevron-down"></i>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                      <div class="dropdown-item input-group clockpicker">
                        <app-detail-info-type-container [hideLabel]="true" [detailInfo]="col.detailInfo"
                          [formGroup]="col.formGroup" [gridView]="true" [noDefaultValue]="true">
                        </app-detail-info-type-container>
                      </div>
                    </ul>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let gridRow of pageData.gridRowLists" id="c_{{gridRow.uuid}}"
              [class.d-none]="!rowMatches(gridRow)">
              <ng-container *ngFor="let contact of gridRow.attendanceContacts">
                <td *ngIf="contact.detailInfo" [class.d-none]="contact.detailInfo.isHiddenByCurrentVariant">
                  <div *ngIf="!contact.detailInfo.gridEdit;else editItem" data-toggle="tooltip" data-placement="top">
                    {{contact.dataStringGridValue}}
                  </div>
                  <ng-template #editItem>
                    <ng-container
                      *ngTemplateOutlet="editItemItem; context:{  $implicit:contact, formGroup: pageData.formGroup.controls[gridRow.uuid] }">
                    </ng-container>
                  </ng-template>
                </td>
              </ng-container>
            </tr>
            <tr *ngIf="hasActiveFilter && !anyRowMatches">
              <td [attr.colspan]="columnsSchema.length" class="text-muted text-center">
                No attendees match the filter.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </form>
  </div>
</div>

<ng-template #editItemItem let-contact let-formGroup="formGroup">
  <app-detail-info-type-container [hideLabel]="true" [detailInfo]="contact.detailInfo"
    [class.d-none]="contact.detailInfo.isHidden" [formGroup]="formGroup" [gridView]="true">
  </app-detail-info-type-container>
</ng-template>